var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBarchart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.3698 21.2429L19.9592 16.7216C20.9541 15.1409 21.5368 13.2747 21.5368 11.2686C21.5368 5.59638 16.9394 1 11.2692 1C5.5989 1 1 5.59785 1 11.2686C1 16.9394 5.59743 21.5373 11.2692 21.5373C13.3589 21.5373 15.3015 20.9088 16.9232 19.8359L21.3323 24.3543C22.1711 25.2152 23.5324 25.2152 24.3698 24.3543C25.2101 23.4962 25.2101 22.0995 24.3698 21.2414V21.2429Z",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.2295 6.1748V15.2302",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3486 8.40771V15.2299",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.46777 15.2306V10.6416",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBarchart);
export default __webpack_public_path__ + "static/media/search-barchart.e94c74ca99a8e1a47ff93ad08cce19c7.svg";
export { ForwardRef as ReactComponent };